module.exports = __webpack_public_path__ + "static/media/radar.483d485f.svg";